@if (columnData() | async; as row) {
  @if ((isAllSelected$ | async) === false && !((selectedRows$ | async)?.has(rowIndexValue))) {
      @if (!tableAction()) {
        <div (click)="toggleActions($event, op)" role="button" aria-label="actions-menu-trigger" class="h-full">
            <div class="h-full border-1 border-200 border-round flex align-items-center justify-content-center cursor-pointer text-gray-600 bg-white hover:bg-gray-50 transition-colors">
                <i class="fa fa-ellipsis text-lg" aria-hidden="true"></i>
            </div>
        </div>
      }

      <p-drawer [visible]="showMobileActions" position="bottom" styleClass="h-auto border-round-top-xl" [modal]="true" [showCloseIcon]="false">
          <div class="flex flex-column gap-2 pb-2">
              <div class="text-center font-bold text-lg mb-2 text-900">{{'CLIENT_PROFILE.ACTIONS' | translate}}</div>
              <div class="flex flex-column gap-1">
                   <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleEditProfileDialog(); showMobileActions = false">
                      <i class="fa fa-pencil text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.EDIT_PROFILE' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="showOpp(); showMobileActions = false">
                      <i class="fa fa-user-plus text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.CREATE_OPPORTUNITY' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="newTask(row); showMobileActions = false">
                      <i class="fa fa-list text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.CREATE_TASK' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="navigateToBillinging(row); showMobileActions = false">
                      <i class="fa fa-plus-circle text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.CREATE_SUBSCRIPTION' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="navigateToBillinging(row); showMobileActions = false">
                      <i class="fa fa-money-bill text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.CHARGE_A_FEE' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleChangePasswordDialog(); showMobileActions = false">
                      <i class="fa fa-lock text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.CHANGE_PASSWORD' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleChangeSaleRepDialog(); showMobileActions = false">
                      <i class="fa fa-users text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.CHANGE_CLIENT_REP' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="attachmentsModal = true; showMobileActions = false">
                      <i class="fa fa-paperclip text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.ATTACHEMENTS' | translate}}</span>
                  </div>
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleAssignKeyFobDialog(); showMobileActions = false">
                      <i class="fa fa-key text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.ASSIGN_CHANGE_KEY_FOB' | translate}}</span>
                  </div>
                  @if(showAssignFitpassAction) {
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleAssignFitpassDialog(); showMobileActions = false">
                      <i class="fa fa-id-card text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.ASSIGN_CHANGE_FITPASS' | translate}}</span>
                  </div>
                }
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleSyncClientDialog(); showMobileActions = false">
                      <i class="fa fa-sync text-xl text-600"></i>
                      <span class="text-900 font-medium">{{'CLIENT_PROFILE.SYNC_CLIENT.TITLE' | translate}}</span>
                  </div>
                  @if (showDeleteDigitalPass()) {
                    <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" [ngClass]="{'opacity-40 pointer-events-none': !row?.is_digital_keyfob}" (click)="toggleDeleteDigitalKeyFobDialog(); showMobileActions = false">
                        <i class="fa fa-key text-xl text-600"></i>
                        <span class="text-900 font-medium">{{'CLIENT_PROFILE.DELETE_DIGITAL_PASS' | translate}}</span>
                    </div>
                  }
                  <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleBlockClientDialog(); showMobileActions = false">
                      <i class="fa fa-times text-xl-circle text-xl text-600"></i>
                      @if (row) {
                          @if (!row?.is_blacklisted) {
                            <span class="text-900 font-medium">{{'CLIENT_PROFILE.BLOCK_CLIENT' | translate}}</span>
                          }
                          @if (row?.is_blacklisted) {
                            <span class="text-900 font-medium">{{'CLIENT_PROFILE.UNBLOCK_CLIENT' | translate}}</span>
                          }
                      }
                  </div>
                  @if (row) {
                    <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="isClientBookingBlocked(row) ? toggleUnblockClientBookingDialog() : toggleBlockClientBookingDialog(); showMobileActions = false">
                        <i class="fa fa-ban text-xl text-600"></i>
                        @if (!isClientBookingBlocked(row)) {
                          <span class="text-900 font-medium">{{'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.MENU_TITLE' | translate}}</span>
                        }
                        @if (isClientBookingBlocked(row)) {
                          <span class="text-900 font-medium">{{'CLIENT_PROFILE.UNBLOCK_CLIENT_BOOKING.MENU_TITLE' | translate}}</span>
                        }
                    </div>
                  }
                  @if (showDeleteClientAction) {
                    <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleDeleteClientDialog(); showMobileActions = false">
                        <i class="fa fa-trash text-xl text-600"></i>
                        <span class="text-900 font-medium">{{'CLIENT_PROFILE.DELETE_CLIENT.MENU_TITLE' | translate}}</span>
                    </div>
                  }
                  @if (row && row.client_status && row.client_status.toLowerCase() ==='prospect') {
                    <div class="p-3 border-round-lg surface-50 hover:surface-100 cursor-pointer flex align-items-center gap-3 transition-colors" (click)="toggleTransferProspectDialog(); showMobileActions = false">
                        <i class="fa fa-exchange-alt text-xl text-600"></i>
                        <span class="text-900 font-medium">{{'CLIENT_PROFILE.TRANSFER_PROSPECT' | translate}}</span>
                    </div>
                  }
              </div>
              <div class="mt-2">
                  <button pButton type="button" label="{{'CLIENT_PROFILE.COMMON.CANCEL' | translate}}" class="p-button-outlined w-full" (click)="showMobileActions = false"></button>
              </div>
          </div>
      </p-drawer>

      <p-popover #op styleClass="overflow-hidden" aria-label="prospect-actions-menu">
          <ng-template #content>
              <div class="p-0">
                  <ul class="list-none m-0 p-0 text-800 text-left text-sm" role="menu">
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleEditProfileDialog(); op.hide()" role="menuitem" aria-label="edit-profile-action">
                          <i class="fa fa-pencil mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.EDIT_PROFILE' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="showOpp(); op.hide()" role="menuitem" aria-label="create-opportunity-action">
                          <i class="fa fa-user-plus mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.CREATE_OPPORTUNITY' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="newTask(row); op.hide()" role="menuitem" aria-label="create-task-action">
                          <i class="fa fa-list mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.CREATE_TASK' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="navigateToBillinging(row); op.hide()" role="menuitem" aria-label="create-subscription-action">
                          <i class="fa fa-plus-circle mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.CREATE_SUBSCRIPTION' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="op.hide()" role="menuitem" aria-label="charge-fee-action">
                          <i class="fa fa-money-bill mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.CHARGE_A_FEE' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangePasswordDialog(); op.hide()" role="menuitem" aria-label="change-password-action">
                          <i class="fa fa-lock mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.CHANGE_PASSWORD' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangeSaleRepDialog(); op.hide()" role="menuitem" aria-label="change-client-rep-action">
                          <i class="fa fa-users mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.CHANGE_CLIENT_REP' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="attachmentsModal = true; op.hide()" role="menuitem" aria-label="attachments-action">
                          <i class="fa fa-paperclip mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.ATTACHEMENTS' | translate}}</span>
                      </li>
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleAssignKeyFobDialog(); op.hide()" role="menuitem" aria-label="assign-key-fob-action">
                          <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.ASSIGN_CHANGE_KEY_FOB' | translate}}</span>
                      </li>
                      @if(showAssignFitpassAction) {
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleAssignFitpassDialog(); op.hide()" role="menuitem" aria-label="assign-fitpass-action">
                          <i class="fa fa-id-card mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.ASSIGN_CHANGE_FITPASS' | translate}}</span>
                      </li>
                      }
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleSyncClientDialog(); op.hide()" role="menuitem" aria-label="sync-client-action">
                          <i class="fa fa-sync mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.SYNC_CLIENT.TITLE' | translate}}</span>
                      </li>
                      @if (showDeleteDigitalPass()) {
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" [ngClass]="{'opacity-40 pointer-events-none': !row?.is_digital_keyfob}" (click)="toggleDeleteDigitalKeyFobDialog(); op.hide()" role="menuitem" aria-label="delete-digital-pass-action">
                          <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.DELETE_DIGITAL_PASS' | translate}}</span>
                        </li>
                      }
                      <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleBlockClientDialog(); op.hide()" role="menuitem" [attr.aria-label]="row?.is_blacklisted ? 'unblock-client-action' : 'block-client-action'">
                          <i class="fa fa-times text-xl-circle mr-3 text-600" aria-hidden="true"></i>
                          @if (row) {
                              @if (!row?.is_blacklisted) {
                                <span>{{'CLIENT_PROFILE.BLOCK_CLIENT' | translate}}</span>
                              }
                              @if (row?.is_blacklisted) {
                                <span>{{'CLIENT_PROFILE.UNBLOCK_CLIENT' | translate}}</span>
                              }
                          }
                      </li>
                      @if (row) {
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="isClientBookingBlocked(row) ? toggleUnblockClientBookingDialog() : toggleBlockClientBookingDialog(); op.hide()" role="menuitem" [attr.aria-label]="isClientBookingBlocked(row) ? 'unblock-client-booking-action' : 'block-client-booking-action'">
                            <i class="fa fa-ban mr-3 text-600" aria-hidden="true"></i>
                            @if (!isClientBookingBlocked(row)) {
                              <span>{{'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.MENU_TITLE' | translate}}</span>
                            }
                            @if (isClientBookingBlocked(row)) {
                              <span>{{'CLIENT_PROFILE.UNBLOCK_CLIENT_BOOKING.MENU_TITLE' | translate}}</span>
                            }
                        </li>
                      }
                      @if (showDeleteClientAction) {
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleDeleteClientDialog(); op.hide()" role="menuitem" aria-label="delete-client-action">
                            <i class="fa fa-trash mr-3 text-600" aria-hidden="true"></i>
                            <span>{{'CLIENT_PROFILE.DELETE_CLIENT.MENU_TITLE' | translate}}</span>
                        </li>
                      }
                      @if (row?.client_status.toLowerCase() ==='prospect') {
                        <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleTransferProspectDialog(); op.hide()" role="menuitem" aria-label="transfer-prospect-action">
                          <i class="fa fa-exchange-alt mr-3 text-600" aria-hidden="true"></i>
                          <span>{{'CLIENT_PROFILE.TRANSFER_PROSPECT' | translate}}</span>
                        </li>
                      }
                  </ul>
              </div>
          </ng-template>
      </p-popover>

      @if (tableAction()) {
        <div class="text-right">
            <button
                pButton
                pRipple
                type="button"
                icon="fa fa-angle-down"
                label="{{'CLIENT_PROFILE.ACTIONS' | translate}}"
                iconPos="right"
                class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
                (click)="action.toggle($event)"
                aria-label="prospect-actions-button"
            ></button>
        </div>
      }
      <p-popover #action styleClass="overflow-hidden text-sm w-17rem" aria-label="prospect-actions-menu">
          <ng-template #content>
            <div class="p-0">
              <ul class="list-none m-0 p-0 text-xs text-600" role="menu">
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleEditProfileDialog(); action.hide()" role="menuitem" aria-label="edit-profile-action">
                    <i class="fa fa-pencil mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.EDIT_PROFILE' | translate}}</span>
                </li>
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="showOpp(); action.hide()" role="menuitem" aria-label="create-opportunity-action">
                    <i class="fa fa-user-plus mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.CREATE_OPPORTUNITY' | translate}}</span>
                </li>
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="newTask(row); action.hide()" role="menuitem" aria-label="create-task-action">
                    <i class="fa fa-list mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.CREATE_TASK' | translate}}</span>
                </li>
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="navigateToBillinging(row); action.hide()" role="menuitem" aria-label="create-subscription-action">
                    <i class="fa fa-plus-circle mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.CREATE_SUBSCRIPTION' | translate}}</span>
                </li>
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangePasswordDialog(); action.hide()" role="menuitem" aria-label="change-password-action">
                    <i class="fa fa-lock mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.CHANGE_PASSWORD' | translate}}</span>
                </li>
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleChangeSaleRepDialog(); action.hide()" role="menuitem" aria-label="change-sales-rep-action">
                    <i class="fa fa-users mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.CHANGE_SALES_REP' | translate}}</span>
                </li>
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="attachmentsModal = true; action.hide()" role="menuitem" aria-label="attachments-action">
                    <i class="fa fa-paperclip mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.ATTACHEMENTS' | translate}}</span>
                </li>
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleAssignKeyFobDialog(); action.hide()" role="menuitem" aria-label="assign-key-fob-action">
                    <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.ASSIGN_CHANGE_KEY_FOB' | translate}}</span>
                </li>
                @if(showAssignFitpassAction) {
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleAssignFitpassDialog(); action.hide()" role="menuitem" aria-label="assign-fitpass-action">
                    <i class="fa fa-id-card mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.ASSIGN_CHANGE_FITPASS' | translate}}</span>
                </li>
                }
                <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleSyncClientDialog(); action.hide()" role="menuitem" aria-label="sync-client-action">
                    <i class="fa fa-sync mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.SYNC_CLIENT.TITLE' | translate}}</span>
                </li>
                @if (showDeleteDigitalPass()) {
                  <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleDeleteDigitalKeyFobDialog(); action.hide()" role="menuitem" aria-label="delete-digital-pass-action">
                    <i class="fa fa-key mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.DELETE_DIGITAL_PASS' | translate}}</span>
                  </li>
                }
                @if (row?.client_status ==='Client' || row?.client_status ==='ClientNonMember') {
                  <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleBlockClientDialog(); action.hide()" role="menuitem" [attr.aria-label]="row?.is_blacklisted ? 'unblock-client-action' : 'block-client-action'">
                      <i class="fa fa-times-circle mr-3 text-600" aria-hidden="true"></i>
                      @if (row) {
                          @if (!row?.is_blacklisted) {
                            <span>{{'CLIENT_PROFILE.BLOCK_CLIENT' | translate}}</span>
                          }
                          @if (row?.is_blacklisted) {
                            <span>{{'CLIENT_PROFILE.UNBLOCK_CLIENT' | translate}}</span>
                          }
                      }
                  </li>
                }
                @if (row) {
                  <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="isClientBookingBlocked(row) ? toggleUnblockClientBookingDialog() : toggleBlockClientBookingDialog(); action.hide()" role="menuitem" [attr.aria-label]="isClientBookingBlocked(row) ? 'unblock-client-booking-action' : 'block-client-booking-action'">
                      <i class="fa fa-ban mr-3 text-600" aria-hidden="true"></i>
                      @if (!isClientBookingBlocked(row)) {
                        <span>{{'CLIENT_PROFILE.BLOCK_CLIENT_BOOKING.MENU_TITLE' | translate}}</span>
                      }
                      @if (isClientBookingBlocked(row)) {
                        <span>{{'CLIENT_PROFILE.UNBLOCK_CLIENT_BOOKING.MENU_TITLE' | translate}}</span>
                      }
                  </li>
                }
                @if (showDeleteClientAction) {
                  <li class="px-3 py-2 flex align-items-center hover:surface-200 cursor-pointer" (click)="toggleDeleteClientDialog(); action.hide()" role="menuitem" aria-label="delete-client-action">
                    <i class="fa fa-trash mr-3 text-600" aria-hidden="true"></i>
                    <span>{{'CLIENT_PROFILE.DELETE_CLIENT.MENU_TITLE' | translate}}</span>
                  </li>
                }
            </ul>
            </div>
             
          </ng-template>
      </p-popover>
  }


  @if (toggleEditProfileDialog$ | async; as showPopup) {
    <create-client-profile-sidebar [showProspect]="showPopup"  [clientData]="colData" [formType]="'prospect'" [formEvent]="'update'"
     (closeEditProfile)="closeEditProfile($event)" aria-label="edit-profile-sidebar" />
  }

  @if (toggleChangePasswordDialog$ | async) {
    <client-profile-change-password
        [changePasswordModal]="toggleChangePasswordDialog$ | async"
        [clientDetails]="(columnData() | async)"
        (closePopup)="closeChangePasswordDialog()"
        [tenantId]="tenantId"
        aria-label="change-password-dialog"
    />
  }

  <!-- Assign Key FOB Modal  -->
  @if (toggleAssignKeyFobDialog$ | async) {
    <assign-key-fob [assignKeyFobModal]="toggleAssignKeyFobDialog$ | async" [clientId]="(columnData() | async)?.id" (closeassignKeyFobModalDialog)="closeAssignKeyFob($event)" aria-label="assign-key-fob-dialog" />
  }
  <!-- Assign Key FOB Modal -->

  <!-- Assign FitPass Modal  -->
  @if (toggleAssignFitpassDialog$ | async) {
    <assign-fitpass [assignFitpassModal]="toggleAssignFitpassDialog$ | async" [clientId]="(columnData() | async)?.id" (closeAssignFitpassModalDialog)="closeAssignFitpass($event)" aria-label="assign-fitpass-dialog" />
  }
  <!-- Assign FitPass Modal -->

  <!-- Block Profile Modal  -->
  @if (toggleBlockClientDialog$ | async) {
    <block-client [blockClientModal]="toggleBlockClientDialog$ | async" [clientData$]="columnData()" (closeBlockClientDialog)="closeBlockClientDialog($event)" aria-label="block-client-dialog" />
  }
  <!-- Block Profile Modal -->

  @if (toggleDeleteDigitalKeyFobDialog$ | async) {
    <delete-digital-pass [deleteDigitalPassModal]="toggleDeleteDigitalKeyFobDialog$ | async" [clientData$]="columnData()" (closeDeleteDigitalPassDialog)="closeDeleteDigitalPassDialog($event)" aria-label="delete-digital-pass-dialog" />
  }

  <!-- Change Sales Rep Modal  -->
  @if (toggleChangeSaleRepDialog$ | async) {
    <change-sales-representative [changeRepresentativeModal]="toggleChangeSaleRepDialog$ | async" [clientData$]="columnData()" (closeChangeRepresentativeDialog)="closeChangeSaleRepDialog($event)" aria-label="change-sales-rep-dialog" />
  }
  <!-- Change Sales Rep Modal  -->

  <!-- Transfer Prospect Modal  -->
  @if (toggleTransferProspectDialog$ | async) {
    <transfer-prospect [transferProspectModal]="toggleTransferProspectDialog$ | async" [clientData$]="columnData()" (closeTransferProspectDialog)="closeTransferProspectDialog($event)" aria-label="transfer-prospect-dialog" />
  }
  <!-- Transfer Prospect Modal  -->

  <!-- Sync Client Modal  -->
  @if (toggleSyncClientDialog$ | async) {
    <sync-client-dialog [visible]="(toggleSyncClientDialog$ | async) ?? false" (onHide)="closeSyncClientDialog(false)" [clientId]="(columnData() | async)?.id" (closePopup)="closeSyncClientDialog($event)" aria-label="sync-client-dialog" />
  }
  <!-- Sync Client Modal  -->

  <!-- Block Client Booking Modal  -->
  @if (toggleBlockClientBookingDialog$ | async) {
    <block-client-booking [blockClientBookingModal]="toggleBlockClientBookingDialog$ | async" [clientData$]="columnData()" (closeBlockClientBookingDialog)="closeBlockClientBookingDialog($event)" aria-label="block-client-booking-dialog" />
  }
  <!-- Block Client Booking Modal  -->

  <!-- Unblock Client Booking Modal  -->
  @if (toggleUnblockClientBookingDialog$ | async) {
    <unblock-client-booking [unblockClientBookingModal]="toggleUnblockClientBookingDialog$ | async" [clientData$]="columnData()" (closeUnblockClientBookingDialog)="closeUnblockClientBookingDialog($event)" aria-label="unblock-client-booking-dialog" />
  }
  <!-- Unblock Client Booking Modal  -->

  <!-- Delete Client Modal  -->
  @if (toggleDeleteClientDialog$ | async) {
    <app-delete-client [deleteClientModal]="toggleDeleteClientDialog$ | async" [clientData$]="columnData()" (closeDeleteClientDialog)="closeDeleteClientDialog($event)" aria-label="delete-client-dialog" />
  }
  <!-- Delete Client Modal  -->

  @if (showCreateOpportunityPopup) {
    <create-opportunity [visible]="showCreateOpportunityPopup" (onHide)="hideOpportunity()" [clientInfo]="clientDetails" (hidePopup)="hideOpportunity()" aria-label="create-opportunity-dialog" />
  }

  @if (showTaskCreate) {
    <app-task-create [showPopup]="showTaskCreate" (HidePopup)="HideTaskCreate()" [clientIds]="clientIds" (closeTaskPopup)="HideTaskCreate()" aria-label="create-task-dialog" />
  }


  <!--NOT COVERED ON THIS SPRINT-->
  @if (attachmentsModal) {
    <attachments [attachmentsModal]="attachmentsModal" (close)="closeAttachmentDialog($event)" [clientId]="selectedClient.get('id').id" [tenantId]="tenantId" aria-label="attachments-dialog" />
  }
 
}
